import { gql } from '@apollo/client';

export * from './escrowInvitationCreate.mutation.generated';

export const ESCROW_INVITATION_CREATE = gql`
  mutation escrowInvitationCreate($escrowId: ID!, $escrowInvitationParams: EscrowInvitationCreateParams!) {
    escrowInvitationCreate(input: { escrowId: $escrowId, escrowInvitationParams: $escrowInvitationParams }) {
      success
      errors
      escrowInvitation {
        ...EscrowInvitationFields
        escrow {
          id
          beneficiaryConfigured
          depositorConfigured
        }
      }
    }
  }
`;
